import React from "react";
import { Flex } from "@chakra-ui/react";
import IMG3 from "./images/imgmod10.png";

export default function Banner4() {
  return (
    <Flex
      align="center"
      justify="center"
      css={{
        backgroundImage: " url(" + IMG3 + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        
        backgroundPosition: "center",
        height: "350px",
      }}
      id="contact"
    ></Flex>
  );
}
